var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#6B51EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6079 17.1721C19.6079 18.0121 19.8469 18.3471 20.4719 18.3471C21.865 18.3471 22.7519 16.5721 22.7519 13.6201C22.7519 9.10813 19.4639 6.94813 15.3589 6.94813C11.1359 6.94813 7.29495 9.78013 7.29495 15.1321C7.29495 20.2441 10.6549 23.0281 15.8149 23.0281C17.5669 23.0281 18.7429 22.8361 20.5419 22.2361L20.9279 23.8431C19.1519 24.4201 17.254 24.5871 15.7909 24.5871C9.02295 24.5871 5.39795 20.8671 5.39795 15.1311C5.39795 9.34713 9.59895 5.41113 15.3829 5.41113C21.4069 5.41113 24.5979 9.01113 24.5979 13.4271C24.5979 17.1711 23.423 20.0271 19.7269 20.0271C18.0459 20.0271 16.9429 19.3551 16.7989 17.8661C16.3669 19.5221 15.2149 20.0271 13.6539 20.0271C11.5659 20.0271 9.81395 18.4181 9.81395 15.1791C9.81395 11.9151 11.3509 9.89913 14.1109 9.89913C15.5749 9.89913 16.4869 10.4751 16.8929 11.3871L17.5899 10.1151H19.6059V17.1721H19.6079ZM16.6569 14.0041C16.6569 12.6851 15.6719 12.1321 14.8559 12.1321C13.9679 12.1321 12.9849 12.8511 12.9849 14.9641C12.9849 16.6441 13.7289 17.5801 14.8559 17.5801C15.6479 17.5801 16.6569 17.0761 16.6569 15.6841V14.0041Z",
    fill: "#E3E3E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.96a099d9ddd98c353c6aeb3925447137.svg";
export { ForwardRef as ReactComponent };